import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VetSettingsState } from './vet-settings.reducer';

const getVetSettingsState = createFeatureSelector<VetSettingsState>('vetSettings');

export const selectMediaCategories = createSelector(
  getVetSettingsState,
  state => state.mediaCategories
);

export const selectViewerTemplates = createSelector(
  getVetSettingsState,
  state => state.viewerTemplates
);

export const selectSaveViewerTemplates = createSelector(
  getVetSettingsState,
  state => state.isSaved
);
// Add other selectors as needed...
